module.exports = __webpack_public_path__ + "static/media/COURSE OVERVIEW.13d2e349.png";